import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import logo from '../images/cuet-img/cuetlogo.png'

const Logo = () => {
    return (
        <Wrapper>
            <Link to='/'>
                <img src={logo} alt="Logo" height='90' />
                <svg width="150" height="100" >

                    <text x="45%" y="65%" text-anchor="middle"  >
                        CUET
                    </text>
                </svg>

            </Link>
        </Wrapper>
    )
}

const Wrapper = styled.section`
           svg text {
            /* position: absolute; */
            z-index:-1;
            background-color: transparent;
            letter-spacing: 5px;
            stroke: #ffa5d8;
            font-size: 50px;
            font-weight: 700;
            stroke-width: 3;
            animation: textAnimate 5s infinite alternate;
        }

        @keyframes textAnimate {
            0% {
                stroke-dasharray: 0 50%;
                stroke-dashoffset:  20%;
                fill:var(--clr-primary-1);

            }
        
            100% {
                stroke-dasharray: 50% 0;
                stroke-dashoffstet: -20%;
                fill: var(--grey-1);
            }
        
        }
`

export default Logo
